import { Link } from "react-router-dom"


const CardTournament = ({ banner, title, url }) => {
    return (
        <div className='border rounded-lg'>
            <Link to={url}>
                <div>
                    <img src={banner} alt={title} />
                </div>
                <div className='p-2 text-center bg-white'>
                    {title}
                </div>
            </Link>
        </div>
    )
}

export default CardTournament
